<ng-container *ngIf="IS_NEW_UI_FLOW">
    <div [ngClass]="{'new-layout': IS_NEW_UI_FLOW, 'modal': isLoginModal, 'page': !isLoginModal}">
        <ion-header>
            <ion-toolbar class="toolbar-header">
                 @if(isLoginModal){
                    <ion-buttons slot="end">
                        <ion-button fill="clear" (click)="goBack()">
                            <ion-icon slot="icon-only" name="close"></ion-icon>
                        </ion-button>
                    </ion-buttons>
                } @else{
                    <ion-buttons slot="start">
                        <ion-back-button [defaultHref]="route"></ion-back-button>
                    </ion-buttons>
                }
            </ion-toolbar>
             
        </ion-header>
        <ion-content>
            <div class="conter-content">
                <div class="header">
                    <figure>
                        <img [src]="logoSquare" alt="logo" />
                    </figure>
                    <h2 class="title" *ngIf="!haveCode">{{'Forgot password' | translate}}</h2>
                    <h2 class="title" *ngIf="haveCode">{{'Change password' | translate}}</h2>
                </div>
                <form *ngIf="!haveCode" [formGroup]="getCodeFormGroup" novalidate>
                    <!-- <ion-item class="input-item ion-margin-bottom" (click)="getCountryCode()">
                        <ion-input readonly type="tel" formControlName="country_code" name="Country code"
                            label="{{'Country' | translate}}" labelPlacement="floating"></ion-input>
                        <ion-icon class="caret-down-outline" slot="end" name="caret-down-outline"></ion-icon>
                    </ion-item> -->
                    <ion-row>
                        <ion-col size="4">
                        <ion-item (click)="getCountryCode()" class="input-item">
                            <ion-input formControlName="country_code" labelPlacement="stacked" label="{{'Country' | translate}}" 
                                [value]="getCodeFormGroup.get('country_code')?.value">
                            </ion-input>
                            <ion-icon class="caret-down-outline" slot="end" name="caret-down-outline"></ion-icon>
                        </ion-item>
                        </ion-col>
                        <ion-col size="8">
                        <ion-item class="input-item">
                            <ion-input inputmode="numeric" placeholder="Area code + Phone" formControlName="phone" labelPlacement="stacked" label="{{'Phone' | translate}}"
                                [value]="getCodeFormGroup.get('phone')?.value">
                            </ion-input>
                        </ion-item>
                        </ion-col>
                    </ion-row>

                    <ion-row>
                        <ion-col size="12" class="or-text">
                            <ion-text color="medium">{{'OR' | translate}}</ion-text>
                        </ion-col>
                    </ion-row>

                    <ion-item class="input-item ion-margin-bottom"
                        [class.ion-invalid]="getCodeFormGroup.get('email')?.invalid && getCodeFormGroup.get('email')?.touched">
                        <ion-input type="text" label="{{'Email' | translate}}" labelPlacement="stacked" formControlName="email" name="emailOrPhone">
                        </ion-input>
                        <ion-note slot="error"
                            *ngIf="getCodeFormGroup.get('email')?.invalid && getCodeFormGroup.get('email')?.touched">
                            <div *ngIf="getCodeFormGroup.get('email')?.errors?.['required']">{{'Email is required' | translate}}
                            </div>
                            <div *ngIf="getCodeFormGroup.get('email')?.errors?.['email']">{{'Please enter a valid email address.' | translate}}</div>
                        </ion-note>
                    </ion-item>

                    <ion-button type="submit" class="primary-button ion-no-margin" expand="block" (click)="getCode()"
                        [disabled]="!isGetCodeFormValid()">
                        {{'Get Code' | translate}}
                    </ion-button>
                    <div class="ion-text-center ion-padding-bottom ion-padding-top">
                        <a (click)="changeForm()">{{'Already have a code? Change password' | translate}}</a>
                    </div>
                </form>

                <form *ngIf="haveCode" class="changePasswordFormGroup" [formGroup]="changePasswordFormGroup" novalidate>

                    <ion-row>
                        <ion-col size="4">
                        <ion-item (click)="getCountryCode()" class="input-item">
                            <ion-input formControlName="country_code" labelPlacement="stacked" label="{{'Country' | translate}}" 
                                [value]="changePasswordFormGroup.get('country_code')?.value">
                            </ion-input>
                            <ion-icon class="caret-down-outline" slot="end" name="caret-down-outline"></ion-icon>
                        </ion-item>
                        </ion-col>
                        <ion-col size="8">
                        <ion-item class="input-item">
                            <ion-input inputmode="numeric" placeholder="Area code + Phone" formControlName="phone" labelPlacement="stacked" label="{{'Phone' | translate}}"
                                [value]="changePasswordFormGroup.get('phone')?.value">
                            </ion-input>
                        </ion-item>
                        </ion-col>
                    </ion-row>

                    <ion-item class="input-item"
                        [class.ion-invalid]="changePasswordFormGroup.get('email')?.invalid && changePasswordFormGroup.get('email')?.touched">
                        <ion-input type="text" label="{{'Or Email' | translate}}" labelPlacement="stacked"
                            formControlName="email" name="email">
                        </ion-input>
                        <ion-note slot="error"
                            *ngIf="changePasswordFormGroup.get('email')?.invalid && changePasswordFormGroup.get('email')?.touched">
                            <div *ngIf="changePasswordFormGroup.get('email')?.errors?.['required']">{{'Email is required' | translate}}</div>
                            <div *ngIf="changePasswordFormGroup.get('email')?.errors?.['email']">{{'Please enter a valid email address.' | translate}}</div>
                        </ion-note>
                    </ion-item>
                    <ion-item class="">
                        <ion-input labelPlacement="stacked" type="text" inputmode="numeric" formControlName="code"
                            name="Code" maxlength="6" pattern="[0-9]*">
                            <div slot="label">{{'Code' | translate}} <ion-text color=""></ion-text></div>
                        </ion-input>
                    </ion-item>
                    <ion-item class="">
                        <ion-input labelPlacement="stacked" label="{{'PASSWORD' | translate}}"
                            [type]="showPassword ? 'text' : 'password'" formControlName="password" name="Password" required>
                            <div slot="label">{{'New Password' | translate}} <ion-text color=""></ion-text></div>
                        </ion-input>
                        <ion-icon slot="end" [name]="showPassword ? 'eye' : 'eye-off'"
                            (click)="togglePasswordVisibility()" class="eye-icon"></ion-icon>
                    </ion-item>
                    <ion-item lines="none" class="password-requirements">
                        <div>
                            <ion-text>{{'Your password must have' | translate}}:</ion-text>
                            <ul style="list-style: none; padding: 0; margin: 0;">
                                <li><ion-icon
                                        [name]="isPasswordLengthValid() ? 'checkbox' : 'square-outline'"></ion-icon> {{'8 or more characters' | translate}}</li>
                                <li><ion-icon [name]="isPasswordCaseValid() ? 'checkbox' : 'square-outline'"></ion-icon>
                                    {{'Upper and lowercase letters' | translate}}</li>
                                <li><ion-icon
                                        [name]="isPasswordNumberValid() ? 'checkbox' : 'square-outline'"></ion-icon> {{'At least one number' | translate}}</li>
                            </ul>
                        </div>
                    </ion-item>
                    <ion-item class="strength-meter">
                        <div *ngIf="changePasswordFormGroup.get('password')?.value">
                            <div class="strength">{{'Strength' | translate}}: <span [class]="getPasswordStrength()">{{
                                    getPasswordStrength() }}</span>
                            </div>
                            <div class="meter">
                                <div class="bar" [ngClass]="getPasswordStrength()"
                                    [style.width]="getPasswordStrength() === 'strong' ? '100%' : getPasswordStrength() === 'medium' ? '60%' : '30%'">
                                </div>
                            </div>
                            <div class="warning" *ngIf="getPasswordStrength() === 'weak'">{{'This password is not secure. Try a different password.' | translate}}</div>
                        </div>
                    </ion-item>
                    <ion-button type="submit" expand="block" class="primary-button" (click)="changePassword()"
                        [disabled]="!isChangePasswordFormValid()">
                        {{'Change Password' | translate}}
                    </ion-button>
                </form>
            </div>
        </ion-content>
    </div>
</ng-container>
<ng-container *ngIf="!IS_NEW_UI_FLOW">
    <ion-text color="primary" class="ion-text-center">
        <h1>{{'Forgot password' | translate}}</h1>
    </ion-text>

    <form *ngIf="!haveCode" [formGroup]="getCodeFormGroup" novalidate>
        <ion-list class="ion-padding">
            <!-- Phone -->

            <ion-row class="ion-padding-none">
                <ion-col size="4">
                    <ion-item (click)="getCountryCode()">
                        <ion-input labelPlacement="floating" readonly type="tel" formControlName="country_code"
                            name="Country code">
                            <div slot="label">{{'Country' | translate}} <ion-text color="danger">*</ion-text></div>
                        </ion-input>
                        <ion-icon class="caret-down-outline" slot="end" name="caret-down-outline"></ion-icon>
                    </ion-item>
                </ion-col>
                <ion-col size="8">
                    <ion-item>
                        <ion-input labelPlacement="floating" type="number" inputmode="numeric" formControlName="phone"
                            name="Phone">
                            <div slot="label">{{'Phone' | translate}} <ion-text color="danger">*</ion-text></div>
                        </ion-input>
                    </ion-item>
                </ion-col>

            </ion-row>

            <div style="height: 10px"></div>
            <ion-button type="submit" expand="block" color="primary" (click)="getCode()" [disabled]="!isGetCodeFormValid()">
                {{'Get Code' | translate}}
            </ion-button>

        </ion-list>

        <div class="ion-text-center ion-padding-bottom ion-padding-top">
            <a (click)="changeForm()">{{'Already have a code? Change password' | translate}}</a>
        </div>

    </form>

    <form *ngIf="haveCode" [formGroup]="changePasswordFormGroup" novalidate>

        <ion-list class="ion-padding">
            <!-- Phone -->

            <ion-row>
                <ion-col size="4">
                    <ion-item (click)="getCountryCode()">
                        <ion-input labelPlacement="floating" readonly type="tel" formControlName="country_code"
                            name="Country code">
                            <div slot="label">{{'Country' | translate}} <ion-text color="danger">*</ion-text></div>
                        </ion-input>
                        <ion-icon class="caret-down-outline" slot="end" name="caret-down-outline"></ion-icon>
                    </ion-item>
                </ion-col>
                <ion-col size="8">
                    <ion-item>
                        <ion-input labelPlacement="floating" type="number" inputmode="numeric" formControlName="phone"
                            name="Phone">
                            <div slot="label">{{'Phone' | translate}} <ion-text color="danger">*</ion-text></div>
                        </ion-input>
                    </ion-item>
                </ion-col>

            </ion-row>
            <ion-item>
                <ion-input labelPlacement="floating" type="text" inputmode="numeric" formControlName="code" name="Code"
                    maxlength="6" pattern="[0-9]*">
                    <div slot="label">{{'Code' | translate}} <ion-text color="danger">*</ion-text></div>
                </ion-input>
            </ion-item>
            <ion-item>
                <ion-input labelPlacement="floating" formControlName="password" name="password" type="password">
                    <div slot="label">{{'New Password' | translate}} <ion-text color="danger">*</ion-text></div>
                </ion-input>
            </ion-item>

            <div style="height: 10px"></div>
            <ion-button type="submit" expand="block" color="secondary" (click)="changePassword()" [disabled]="!isChangePasswordFormValid()">
                {{'Change Password' | translate}}
            </ion-button>

        </ion-list>

    </form>
</ng-container>